import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleaverGlossary'
})
export class CleaverGlossaryPipe implements PipeTransform {

  public glossary = [
    { "Persuasivo": "capaz de llevar a otro a creer o hacer algo" },
    { "Gentil": "aquel que en su trato es amable" },
    { "Humilde": "que demuestra sencillez y docilidad" },
    { "Original": "especial, único, distinto a los demás" },
    { "Agresivo": "aquel que ataca u ofende a los demás" },
    { "Alma de la fiesta": "el que es alegre, entusiasta" },
    { "Comodino (cómodo)": "el que busca lo agradable con el menor esfuerzo" },
    { "Temeroso": "aquel que es miedoso, cobarde" },
    { "Agradable": "aquel que es grato y atrayente" },
    { "Temeroso de Dios": "que tiene miedo al castigo divino" },
    { "Tenaz": "aquel que es constante para alcanzar sus objetivos" },
    { "Atractivo": "aquel que con sus cualidades capta la atención" },
    { "Cauteloso": "precavido, que actúa previendo posibles dificultades" },
    { "Determinado": "resuelto y decidido" },
    { "Convincente": "que consigue que una idea o hecho se acepten como verdad" },
    { "Bonachón": "aquel que es accesible, cordial y/o crédulo" },
    { "Dócil": "aquel que fácilmente se amolda a los requerimientos" },
    { "Atrevido": "que actúa de manera arriesgada, con decisión y arrojo" },
    { "Leal": "que es fiel a personas o ideales" },
    { "Encantador": "que cautiva la atención, seductor" },
    { "Dispuesto": "disponible, preparado y con ánimo favorable para participar" },
    { "Deseoso": "que anhela poseer, o realizar una cierta actividad" },
    { "Consecuente": "aquel con quien es fácil llegar a un acuerdo" },
    { "Entusiasta": "el que se siente motivado" },
    { "Fuerza de voluntad": "con convencimiento interno y tenacidad para alcanzar un objetivo" },
    { "Mente abierta": "que es tolerante y acepta ideas nuevas y distintas a las suyas" },
    { "Complaciente": "el que busca ser agradable y dar satisfacción a otros" },
    { "Animoso": "que muestra energía, motivación y deseos para hacer algo" },
    { "Confiado": "satisfecho de si mismo, crédulo, ingenuo" },
    { "Simpatizador": "el que trata de mantener relaciones agradables con los demás" },
    { "Tolerante": "que respeta y sobrelleva aquello que no le es familiar" },
    { "Afirmativo": "que sostiene sus ideas o actitudes con determinación" },
    { "Ecuánime": "aquella persona que se muestra equilibrada y serena" },
    { "Preciso": "que es exacto y conciso" },
    { "Nervioso": "que es irritable, inquieto, impresionable" },
    { "Jovial": "alegre, festivo, divertido" },
    { "Disciplinado": "que sigue un método de manera continua" },
    { "Generoso": "que da lo que tiene" },
    { "Persistente": "que es constante y tenaz en una actividad que se propone" },
    { "Competitivo": "que tiene la disposición y características para rivalizar" },
    { "Alegre": "que se muestra contento y regocijado. Gozoso" },
    { "Considerado": "que es atento y toma en cuenta a los demás" },
    { "Armonioso": "que busca el acuerdo, la convivencia, lo equilibrado" },
    { "Admirable": "notable, digno de respeto y aprecio" },
    { "Bondadoso": "que se inclina hacer el bien, amable" },
    { "Resignado": "que se conforma con la situación en la que vive" },
    { "Carácter firme": "que es comprometido con sus convicciones" },
    { "Obediente": "que se apega a lo establecido" },
    { "Quisquilloso": "que toma en cuenta hasta el más mínimo detalle, susceptible" },
    { "Inconquistable": "alguien de quien es muy difícil obtener el aprecio o aceptación" },
    { "Juguetón": "travieso, inquieto" },
    { "Respetuoso": "que toma en cuenta y acata la reglas" },
    { "Emprendedor": "que propone e inicia proyectos" },
    { "Optimista": "que ve las cosas de manera favorable" },
    { "Servicial": "dispuesto a complacer y ayudar" },
    { "Valiente": "que enfrenta el peligro" },
    { "Inspirador": "que hace surgir ideas creativas" },
    { "Sumiso": "que es manejable, dócil, obediente" },
    { "Tímido": "que se muestra poco abierto con las personas" },
    { "Adaptable": "que se acomoda o ajusta a circunstancias y condiciones" },
    { "Disputador": "el que discute sus razonamientos para demostrar algo" },
    { "Indiferente": "el que no tenga preferencia o interés por algo" },
    { "Sangre Liviana": "que en su manera de ser es agradable y atractivo, con carisma" },
    { "Amiguero": "que gusta de establecer relaciones afectuosas" },
    { "Paciente": "que tiene la capacidad para esperar con tranquilidad" },
    { "Confianza en si mismo": "que se siente seguro y satisfecho con su manera de ser y actuar." },
    { "Mesurado para hablar": "que evita los excesos al expresarse verbalmente" },
    { "Conforme": "que se resigna a las circunstancias" },
    { "Confiable": "que inspira un sentimiento de seguridad" },
    { "Pacifico": "tranquilo, que está en paz, que evita peleas" },
    { "Positivo": "que muestra lo que es cierto, real autentico." },
    { "Aventurero": "que gusta de tener experiencias novedosas y arriesgadas" },
    { "Receptivo": "que percibe fácilmente sentimientos, ideas y hechos" },
    { "Cordial": "que es respetuoso y amable con su trato" },
    { "Moderado": "el que en su conducta se mantiene alejado de los extremos" },
    { "Indulgente": "que es tolerante respecto a errores, que perdona fácilmente" },
    { "Esteta (estético)": "el que gusta de lo bello" },
    { "Vigoroso": "que tiene energía, fuerza y vitalidad" },
    { "Sociable": "que busca la convivencia con sus semejantes" },
    { "Parlanchín": "que habla mucho" },
    { "Controlado": "que se domina y frena a si mismo" },
    { "Convencional": "apegado a las costumbres, evita cambios e innovaciones" },
    { "Decisivo": "que es tajante, terminante y definitivo" },
    { "Cohibido": "que se siente restringido, intimidado para actuar, avergonzado" },
    { "Exacto": "el que cuida los más pequeños detalles, conciso" },
    { "Franco": "el que dice lo que piensa abiertamente, comunicativo" },
    { "Buen compañero": "atento, cortés, respetuoso, cooperativo" },
    { "Diplomático": "que tiene tacto y delicadeza en su trato" },
    { "Audaz": "que se atreve a correr riesgos" },
    { "Refinado": "distinguido, muy fino y delicado" },
    { "Satisfecho": "que se siente complacido con lo que ha logrado" },
    { "Inquieto": "que está en constante actividad" },
    { "Popular": "que es aceptado y querido en un grupo" },
    { "Buen vecino": "respetuoso, amable, considerado" },
    { "Devoto": "que vive de acuerdo a costumbres e ideas religiosas" }
  ]

  transform(value: string): string {
  if (!value) {
      return '';
  }
  const entry = this.glossary.find(item => item.hasOwnProperty(value));


  if (entry) {
      return entry[value];
  }
  return value;
  }

}
